import { sortKeys } from "@/constants/Category";
import ProductCard from "../global/ProductCard";
import ArrowIcon from "../icons/ArrowIcon";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";

const CategoryProducts = ({
  allProducts,
  handleSorting,
  setSortName,
  sortName,
  /* allSortingKeys, */ t,
  name,
}) => {
  const [pageLoading, setPageLoading] = useState(true);
  useEffect(() => {
    setPageLoading(false);
  }, []);
  const { locale } = useRouter();

  return (
    !pageLoading && (
      <div>
        <div className="flex items-center justify-between flex-wrap gap-2 mb-4">
          <p className="text-center text-2xl max-sm:text-[15px] font-bold">
            {name ? name : t("Browse all Products")}
          </p>
          <div className="max-sm:hidden flex items-center max-sm:text-[12px] gap-2">
            <span className="text-[#6C6C6C]">{t("Sort By")} : </span>
            <div className="flex items-center font-semibold gap-2 text-secondary-700 relative group cursor-pointer">
              <span className="uppercase">{t(sortName)}</span>
              <ArrowIcon className="size-3 rotate-90" />
              <ul
                className={`hidden group-hover:block absolute top-full ${
                  locale === "en" ? "right-0" : "left-0"
                } w-full min-w-52 border shadow-lg rounded-md bg-white p-2 z-50 *:text-[15px] *:text-black *:cursor-pointer`}
              >
                {sortKeys?.map((item, key) => (
                  <li
                    key={key}
                    onClick={() => {
                      handleSorting({ keys: item?.key });
                      setSortName(item?.label);
                    }}
                    className={`hover:text-secondary-700 ${
                      sortKeys?.length - 1 == key ? "mb-0" : "mb-1.5"
                    } `}
                  >
                    {t(item?.label)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2.5 sm:gap-5">
          {Array.isArray(allProducts)
            ? allProducts?.map((product) => (
                <ProductCard product={product} key={product?.sku} />
              ))
            : null}
          <div id="afterProductsSection" className="w-full"></div>
        </div>
      </div>
    )
  );
};

export default CategoryProducts;
